module.exports = __webpack_public_path__ + "img/plumbing-repair-03-large.b1a6cea4.jpg";